import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=659f4ab2&scoped=true&"
import script from "./Year.vue?vue&type=script&lang=js&"
export * from "./Year.vue?vue&type=script&lang=js&"
import style0 from "./Year.vue?vue&type=style&index=0&id=659f4ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f4ab2",
  null
  
)

export default component.exports